module.exports = __webpack_public_path__ + "img/mind_network_normal.48965007.png";